import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgView2D = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15 8V16H13.481L10.519 10.6374V16H9V8H10.519L13.4861 13.3681V8H15Z",
		fill: "black"
	})
});
export default SvgView2D;
